// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormJob } from '~/utils/interface/jobs';
import { EMPTY_STRING } from '~/utils/constants/common';

export const schema = (t: TFunction): yup.ObjectSchema<IFormJob> => {
  return yup.object().shape({
    id: yup.string().trim().optional(),
    title: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    orderId: yup.string().trim().optional(),
    driverId: yup.string().trim().optional(),
    truckId: yup.string().trim().optional(),
    trailerId: yup.string().trim().optional(),
    foremanId: yup.string().trim().optional(),
    loaderId: yup.array().optional(),
    type: yup.string().trim().optional(),
    startDate: yup.string().optional(),
    startTime: yup.string().trim().optional(),
    endDate: yup.string().optional(),
    endTime: yup.string().trim().optional(),
    color: yup.string().trim().optional(),
    crewIds: yup.array().optional(),
    trailerType: yup.array().optional().nullable(),
  });
};

export const defaultValuesJobForm: IFormJob = {
  id: EMPTY_STRING,
  title: EMPTY_STRING,
  driverId: EMPTY_STRING,
  truckId: EMPTY_STRING,
  loaderId: [],
  trailerType: [],
  trailerId: EMPTY_STRING,
  foremanId: EMPTY_STRING,
  crewIds: [],
  type: EMPTY_STRING,
  startDate: EMPTY_STRING,
  startTime: EMPTY_STRING,
  endDate: EMPTY_STRING,
  endTime: EMPTY_STRING,
  color: EMPTY_STRING,
};
